import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';
import { ICountries, IRegion, ICountry, IGeographicRegion, ICity } from '../_entities'

@Injectable()
export class CommonService {
    private cache = {};
    private countries: ICountries;
    private regions: IRegions;

    constructor(private readonly httpService: HttpService) { }

 
    getCountries(refresh: boolean = false): Promise<ICountries> {

        if (refresh || !this.countries) {
            return new Promise<ICountries>((resolve, reject) => {
                this.httpService.get<ICountry[]>('/api/country').then(countries => {
                    this.countries = {};
                    countries.forEach(x => this.countries[x.code.toUpperCase()] = x);
                    resolve(this.countries);
                });
            });
        }
        return Promise.resolve(this.countries);
    }

    getCountriesList(refresh: boolean = false): Promise<ICountry[]> {
        return this.getCountries(refresh).then(x => {
            let countries = [];
            for (let key of Object.keys(x)) {
                countries.push(x[key]);
            }
            return countries;
        });
    }

    getCitiesInRegion(region: IGeographicRegion, refresh: boolean = false): Promise<ICity[]> {
        let cacheKey = region.country.code + '_' + region.name;
        if (refresh || !this.cache[cacheKey]) {
            this.cache[cacheKey] = new Promise<ICity[]>((resolve, reject) => {
                let regionName = region.name.replace("/", "__");
                this.httpService.get<ICity[]>('/api/city/' + region.country.code + '/' + encodeURI(regionName)).then(regions => {
                    resolve(regions);
                }, error => {
                    console.log(error);
                });
            });
        }

        return this.cache[cacheKey];
    }

    getRegions(): Promise<IRegion[]> {
        return this.getRegionsInternal().then(x => {
            let regions = [];
            for (let key in x) {
                regions.push(...x[key]);
            }
            return regions;
        });
    }

    getRegionsInCountry(countryCode: string, refresh: boolean = false): Promise<IGeographicRegion[]> {
        if (refresh || !this.cache[countryCode]) {
            this.cache[countryCode] = new Promise<IGeographicRegion[]>((resolve, reject) => {
                this.httpService.get<IGeographicRegion[]>('/api/geographicregion/' + countryCode).then(regions => {
                    resolve(regions);
                }, error => {
                    console.log(error);
                });
            });
        }

        return this.cache[countryCode];
    }

    private getRegionsInternal(): Promise<IRegions> {
        return new Promise<IRegions>((resolve, reject) => {
            this.httpService.get<IRegion[]>('/api/region').then(regions => {
                this.regions = {};
                regions.forEach(x => {
                    let code = x.country.code.toUpperCase();
                    if (!this.regions[code]) {
                        this.regions[code] = [];
                    }
                    this.regions[code].push(x);
                });
                resolve(this.regions);
            }, error => {
                console.log(error);
            });
        });
    }
}

interface IRegions {
    [code: string]: IRegion[];
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/common.service.ts